module.exports = __webpack_public_path__ + "img/process-3.241f79c7.png";